var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertificateCheckmark = function SvgCertificateCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.902 14.951a.93.93 0 0 1 .69.185l.902.693c.299.229.714.229 1.011 0l.937-.72a.829.829 0 0 1 .614-.164l1.172.154a.83.83 0 0 0 .876-.505l.45-1.09a.827.827 0 0 1 .45-.45l1.09-.451a.83.83 0 0 0 .506-.876l-.148-1.13a.93.93 0 0 1 .185-.69l.692-.902a.83.83 0 0 0 0-1.01l-.719-.937a.83.83 0 0 1-.164-.614l.154-1.172a.83.83 0 0 0-.506-.876l-1.09-.45a.827.827 0 0 1-.45-.45l-.45-1.09a.83.83 0 0 0-.876-.507l-1.172.155a.825.825 0 0 1-.613-.163l-.937-.72a.829.829 0 0 0-1.01 0l-.937.72a.836.836 0 0 1-.615.164l-1.171-.154a.83.83 0 0 0-.876.506l-.45 1.09a.838.838 0 0 1-.45.45l-1.09.45a.83.83 0 0 0-.506.876l.154 1.171a.833.833 0 0 1-.164.614l-.72.936a.83.83 0 0 0 0 1.011l.72.937a.829.829 0 0 1 .164.614l-.154 1.172a.83.83 0 0 0 .506.876l1.09.45a.827.827 0 0 1 .45.45l.45 1.09a.83.83 0 0 0 .877.506l1.128-.149",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m11.333 7.334-2.918 2.918-1.749-1.75",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgCertificateCheckmark;